export enum TransactionsColumns {
	id = "Id",
	org = "Org",
	accountId = "Account",
	customer = "Customer",
	type = "Type",
	amount = "Amount",
	balance = "Balance",
	summary = "Summary",
	createdAt = "Created At",
}

export type AllowedTransactionsColumns =
	| TransactionsColumns.id
	| TransactionsColumns.org
	| TransactionsColumns.accountId
	| TransactionsColumns.customer
	| TransactionsColumns.type
	| TransactionsColumns.amount
	| TransactionsColumns.balance
	| TransactionsColumns.summary
	| TransactionsColumns.createdAt
